export default new class footerNavComponent {
  constructor() {
    this.linkSelector = 'footer-nav__item-title';
    this.activeLinkSelector = 'footer-column__list-active';
    this.contentSelector = 'footer-nav__subnav';
    this.invisibleContentSelector = 'footer-column__list-hidden';
    this.mediaQueryList = window.matchMedia('(min-width: 769px)');
    this.init();
  }

  init() {
    $(document)
      .on('click', `.${this.linkSelector}`, (e) => {
        e.preventDefault();
        const vpCondition = this.mediaQueryList.matches;

        if (vpCondition) {
          return;
        }
        const { target } = e;

        if ($(target)
          .hasClass(this.activeLinkSelector)) {
          this.hideTab();
          return;
        }

        this.showTab(target);
      });
  }

  showTab(target) {
    const id = $(target)
      .attr('href');
    const tabContent = $(id);

    this.hideTab();

    $(target)
      .addClass(this.activeLinkSelector);

    tabContent.removeClass(this.invisibleContentSelector);
  }

  hideTab() {
    const tabCollection = $(`.${this.linkSelector}`);
    const tabContentCollection = $(`.${this.contentSelector}`);

    [...tabCollection].forEach(tab => $(tab)
      .removeClass(this.activeLinkSelector));
    [...tabContentCollection].forEach(el => $(el)
      .addClass(this.invisibleContentSelector));
  }
}();
